<template>
    <!-- 机台运营报表 -->
    <div class="rzy-page">
        <el-date-picker v-model="selectMonth" type="month" placeholder="选择月" @change="changeMonth" />
        <el-button type="success" @click="initExcel('machineCountTable')">导出Excel</el-button>
        <el-table :data="machineCountList" :header-cell-style="{'text-align':'center'}" id="machineCountTable"
            :cell-style="{'text-align':'center','padding':'0px'}" border stripe max-height="600">
            <el-table-column v-for="(value,key,index) in machineCountKeys" :key="index" :label="value" :prop="key" />
        </el-table>
    </div>
</template>

<script>
    export default {
        name: 'machineCount',
        data() {
            return {
                machineCountList: [],
                selectMonth: '',
                machineCountKeys: {
                    WorkStop: '车间',
                    title: '机台',
                    meanRunningRate: '月平均开机率',
                    sumRunningTime: '月运行时长',
                    sumCapacity: '月产能(米)',
                    //----------------------
                    chuanShaNum: '月穿纱次数',
                    chuanShaSumTime: '月穿纱耗时',
                    chuanShaMeanTime: '月穿纱平均耗时',
                    //----------------------
                    panTouNum: '月盘头次数',
                    panTouSumTime: '月盘头耗时',
                    panTouMeanTime: '月盘头平均耗时',
                    //----------------------
                    jiXiuNum: '月机修次数',
                    jiXiuSumTime: '月机修耗时',
                    jiXiuMeanTime: '月机修平均耗时'
                }
            }
        },
        methods: {
            // 获取当前月的机台运营数据
            getNowCount() {
                const now = new Date().getTime()
                this.selectMonth = now
                this.getMachineCountList(this.utils.getFirstTimeByMonth(now), this.utils.getLastTimeByMonth(now))
            },
            // 切换月份
            changeMonth(val) {
                const selectTime = val.getTime()
                this.getMachineCountList(this.utils.getFirstTimeByMonth(selectTime), this.utils.getLastTimeByMonth(
                    selectTime))
            },
            // 获取开始到结束时间的机台运营数据
            getMachineCountList(startTime, endTime) {
                return this.$requestBase({
                    url: 'v1/factory/machine/count/operation/report',
                    method: 'GET',
                    params: {
                        startTime,
                        endTime
                    }
                }).then((res) => {
                    this.machineCountList = this.formatMachineCount(res.data)
                })
            },
            // 格式化机台运营数据,按机台分
            formatMachineCount(response) {
                var dailyDataGroup = this._.groupBy(response.dailyDataList, (item) => {
                    return item.machineId
                })
                var stateTimeGroup = this._.groupBy(response.machineStateTimeList, (item) => {
                    return item.machineId
                })
                var formatArr = this.completionMachine(response.machineList, dailyDataGroup)
                for (var machineId in dailyDataGroup) {
                    var sumRunningTime = 0
                    var sumCapacity = 0
                    var sumStateNum = [0, 0, 0]
                    var sumStateTime = [0, 0, 0]
                    const dailyData = dailyDataGroup[machineId]
                    var stateTimeData = []
                    if (this._.has(stateTimeGroup, machineId)) {
                        stateTimeData = stateTimeGroup[machineId]
                    }

                    dailyData.forEach((item) => {
                        sumRunningTime += item.runningTime
                        sumCapacity += item.productMeter
                    })
                    stateTimeData.forEach((item) => {
                        const type = item.category //this.utils.formatEnum(item.category)[0]
                        sumStateNum[type] += 1
                        sumStateTime[type] += item.endTime - item.startTime
                    })

                    const chuanShaNum = sumStateNum[0]
                    const panTouNum = sumStateNum[1]
                    const jiXiuNum = sumStateNum[2]
                    const chuanShaSumTime = sumStateTime[0]
                    const panTouSumTime = sumStateTime[1]
                    const jiXiuSumTime = sumStateTime[2]
                    
                    var formatObj = {
                        title: dailyData[0].machineNum,
                        WorkStop: dailyData[0].machineWorkShop,
                        machineId: dailyData[0].machineId,
                        machineNum: dailyData[0].machineNum,
                        machineWorkShop: dailyData[0].machineWorkShop,
                        
                        //251024 0.96%不对，应该是96.xx% -sta
                        // meanRunningRate: (sumRunningTime / (dailyData.length * 86400)).toFixed(2) + '%',
                        meanRunningRate: (sumRunningTime / (dailyData.length * 86400) * 100).toFixed(2) + '%',
                        //251024 0.96%不对，应该是96.xx% -end

                        sumRunningTime: this.utils.secondToHour(sumRunningTime),
                        sumCapacity: this.utils.toMeter(sumCapacity),
                        //----------------------
                        chuanShaNum: chuanShaNum,
                        chuanShaSumTime: chuanShaNum > 0 ? this.utils.milliToHour(chuanShaSumTime) : '0',
                        chuanShaMeanTime: chuanShaNum > 0 ? this.utils.milliToHour(chuanShaSumTime / chuanShaNum) : '0',
                        //----------------------
                        panTouNum: panTouNum,
                        panTouSumTime: panTouNum > 0 ? this.utils.milliToHour(panTouSumTime) : '0',
                        panTouMeanTime: panTouNum > 0 ? this.utils.milliToHour(panTouSumTime / panTouNum) : '0',
                        //----------------------
                        jiXiuNum: jiXiuNum,
                        jiXiuSumTime: jiXiuNum > 0 ? this.utils.milliToHour(jiXiuSumTime) : '0',
                        jiXiuMeanTime: jiXiuNum > 0 ? this.utils.milliToHour(jiXiuSumTime / jiXiuNum) : '0'
                    }
                    //formatObj.title = `${formatObj.machineNum}(${formatObj.machineWorkShop})`
                    formatArr.push(formatObj)
                }
                formatArr = this._.sortBy(formatArr, (obj) => {
                    // 默认升序 降序return的结果加 - ，-obj.machine.number
                    // 提取字母 obj.machineNumber.replace(/[^a-z]+/ig,"");
                    var machineNumber = obj.machineNum.replace(/[^0-9]+/gi, '')
                    return Number(machineNumber)
                })
                const formatSum = this.formatSumCount(response)
                return formatSum.concat(formatArr)
            },
            // 补全无数据的机台
            completionMachine(machineList, dailyDataGroup) {
                const formatArr = []
                machineList.forEach((item) => {
                    if (!this._.has(dailyDataGroup, item.machineId)) {
                        var formatObj = {
                            title: item.machineNum,
                            WorkStop: item.machineWorkShop,
                            machineId: item.machineId,
                            machineNum: item.machineNum,
                            machineWorkShop: item.machineWorkShop,
                            meanRunningRate: '0%',
                            sumRunningTime: '0',
                            sumCapacity: '0',
                            //----------------------
                            chuanShaNum: '0',
                            chuanShaSumTime: '0',
                            chuanShaMeanTime: '0',
                            //----------------------
                            panTouNum: '0',
                            panTouSumTime: '0',
                            panTouMeanTime: '0',
                            //----------------------
                            jiXiuNum: '0',
                            jiXiuSumTime: '0',
                            jiXiuMeanTime: '0'
                        }
                        //formatObj.title = `${formatObj.machineNum}(${formatObj.machineWorkShop})`
                        formatArr.push(formatObj)
                    }
                })
                return formatArr
            },
            // 抽出汇总逻辑
            formatSumCount(reponse) {
                const dailyData = reponse.dailyDataList
                const stateTime = reponse.machineStateTimeList
                var sumRunningTime = 0
                var sumCapacity = 0
                var sumStateNum = [0, 0, 0]
                var sumStateTime = [0, 0, 0]
                dailyData.forEach((item) => {
                    sumRunningTime += item.runningTime
                    sumCapacity += item.productMeter
                })
                stateTime.forEach((item) => {
                    const type = item.category // this.utils.formatEnum(item.category)[0]
                    sumStateNum[type] += 1
                    sumStateTime[type] += item.endTime - item.startTime
                })
                
                const chuanShaNum = sumStateNum[0]
                const panTouNum = sumStateNum[1]
                const jiXiuNum = sumStateNum[2]
                const chuanShaSumTime = sumStateTime[0]
                const panTouSumTime = sumStateTime[1]
                const jiXiuSumTime = sumStateTime[2]
                
                var formatSumObj = [{
                    WorkStop: '汇总',
                    //251024 0.96%不对，应该是96.xx% -sta
                    // meanRunningRate: (sumRunningTime / (dailyData.length * 86400)).toFixed(2) + '%',
                    meanRunningRate: (sumRunningTime / (dailyData.length * 86400) * 100).toFixed(2) + '%',
                    //251024 0.96%不对，应该是96.xx% -end
                    sumRunningTime: this.utils.secondToHour(sumRunningTime),
                    sumCapacity: this.utils.toMeter(sumCapacity),
                    //----------------------
                    chuanShaNum: chuanShaNum,
                    chuanShaSumTime: chuanShaNum > 0 ? this.utils.milliToHour(chuanShaSumTime) : '0',
                    chuanShaMeanTime: chuanShaNum > 0 ? this.utils.milliToHour(chuanShaSumTime / chuanShaNum) : '0',
                    //----------------------
                    panTouNum: panTouNum,
                    panTouSumTime: panTouNum > 0 ? this.utils.milliToHour(panTouSumTime) : '0',
                    panTouMeanTime: panTouNum > 0 ? this.utils.milliToHour(panTouSumTime / panTouNum) : '0',
                    //----------------------
                    jiXiuNum: jiXiuNum,
                    jiXiuSumTime: jiXiuNum > 0 ? this.utils.milliToHour(jiXiuSumTime) : '0',
                    jiXiuMeanTime: jiXiuNum > 0 ? this.utils.milliToHour(jiXiuSumTime / jiXiuNum) : '0'
                }]
                return formatSumObj
            },
            // 导出excel初始化
            initExcel(id) {
                const select = new Date(this.selectMonth)
                const year = select.getFullYear()
                const month = select.getMonth() + 1
                this.utils.exportExcel(id, `${year}年${month}月机台运营报表`)
            }
        },
        created() {
            this.getNowCount()
        }
    }
</script>

<style lang="scss"></style>